import * as React from 'react';
import { Button, Accordion, Card, Row, Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DropDownSelect } from "./component/DropDownSelect";
import { CreateContact } from "./component/CreateContact";
import { ContactSlideout } from "./component/ContactSlideout";
import BootstrapTable from "react-bootstrap-table-next";
import { SalesService } from "../../Common/Services/SalesService";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import "./sales.scss";
import { Utils } from '../../Common/Utilis';

export class Overview extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            accountsPermissionArray: props.accountsPermissionArray,
            detailsToggle: true,
            addressToggle: true,
            showTooltip: false,
            selectedAccount: props.selectedAccount,
            accountsList: [],
            accountsListCopy: [],
            accountDetails: {
                accountId: -1, accountName: "", lettercode: "", ehidValue: -1, status: 1, statusName: "Lead", accountScore: -1, accountScoreName: "",
                owner: -1, ownerName: "", source: -1, sourceName: "", marketSegment: -1, marketSegmentName: "", website: "", taxId: "", iata: "",
                targetAccount: "no", isEdit: "no",
            },
            accountAddressDetails: {
                addressId: -1, accountId: -1, country: "United States", countryCode: "USA", street: "", city: "",
                state: "", stateCode: "", zipcode: "", isEdit: "no",
            },
            accountDetailsCopy: {
                accountId: -1, accountName: "", lettercode: "", ehidValue: -1, status: 1, statusName: "Lead", accountScore: -1, accountScoreName: "",
                owner: -1, ownerName: "", source: -1, sourceName: "", marketSegment: -1, marketSegmentName: "", website: "", taxId: "", iata: "",
                targetAccount: "no", isEdit: "no",
            },
            accountAddressDetailsCopy: {
                addressId: -1, accountId: -1, country: "United States", countryCode: "USA", street: "", city: "",
                state: "", stateCode: "", zipcode: "", isEdit: "no",
            },
            salesEhidList: [],
            statusList: [],
            accountScoreList: [
                { name: "Select Score", eventKey: "score_-1", id: -1 },
                { name: "1 (Low)", eventKey: "score_1", id: 1 },
                { name: "2 (Medium)", eventKey: "score_2", id: 2 },
                { name: "3 (High)", eventKey: "score_3", id: 3 },
            ],
            ownerList: [],
            sourceList: [],
            margetSegmentList: [],
            countriesAndStatesList: [],
            countriesList: [],
            statesList: [],
            errors: {
                accountName: "", lettercode: '', statusName: "", address: "", zipCode: "", contact: "", email: "", phone: "",
            },
            isAddressMandatory: false,
            contactData: [],
            upcomingTasksData: [],
            isCreateContact: false,
            isShowContactSlideout: false,
            selectedContact: {},
        };
    }

    componentDidMount() {
         // SetTimeout added because multiple API's are being called and always some API fails
        this.loadDropDownDataForCreateAccnt();
        this.setState({ selectedAccount: this.props?.selectedAccount }, () => {             
            setTimeout(() => {
                this.getSalesAgent(this.state.selectedAccount.hotelID);  // API for Owner Dropdown
            }, 10);
            setTimeout(() => {
                this.getSalesAccountDetails(this.state.selectedAccount?.accountID); // API for Account Details
            }, 50);

            setTimeout(() => {                
                this.getSalesAccountAddressDetails(this.state.selectedAccount?.accountID); // API for Account Address Details
            }, 75);
            setTimeout(() => {
                this.GetSalesContactById();  // API for contacts container
            }, 100);
            setTimeout(() => {
                this.GetSalesTaskById();   // API for Tasks container
            }, 125);
        });
    }

    // componentDidUpdate(prevProps, prevState) {
    //     // debugger;
    //     if (prevProps?.selectedAccount !== this.props?.selectedAccount) {
    //         this.setState({ selectedAccount: this.props?.selectedAccount }, () => {
    //             this.getSalesAgent(this.state.selectedAccount.hotelID);  // API for Owner Dropdown
    //             this.getSalesAccountDetails(this.state.selectedAccount?.accountID);
    //             this.getSalesAccountAddressDetails(this.state.selectedAccount?.accountID);
    //             this.GetSalesContactById();
    //             this.GetSalesTaskById();
    //         });
    //     }
    // }


    getSalesAccountDetails = (accountId) => {
        //API to get Data for Account Details
        let request: any = {};
        request.accountId = accountId;
        SalesService.getSalesAccountDetails(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result.result != null) {
                    this.setState({ accountDetails: result.result, accountDetailsCopy: result.result }, () => {
                        this.props?.updateAccNameOrStatus(this.state.accountDetails);
                    });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to Account Details.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-1a",
                });
                reject();
            });
    }

    getSalesAccountAddressDetails = (accountId) => {
        //API to get Data for Account Details
        let request: any = {};
        request.AccountId = accountId;
        SalesService.getSalesAccountAddressDetails(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result.result != null) {
                    this.setState({ accountAddressDetails: result.result, accountAddressDetailsCopy: result.result });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to Account Address Details.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-2a",
                });
                reject();
            });
    }

    loadDropDownDataForCreateAccnt = () => {
        // SetTimeout added because multiple API's are being called and always some API fails
        setTimeout(() => {
            this.getSalesEHID("UserWise");    // API for EHID Dropdown Data for Create Account
        }, 150);
        setTimeout(() => {
            this.getSalesStatus();     // API for EHID Dropdown Data for Create Account  
        }, 200);
        setTimeout(() => {          
            this.getSalesSource();   //  API for Source Dropdown Data for Create Account 
        }, 250);
        setTimeout(() => {
            this.getSalesMarketSegment();  //  API for Market segment Dropdown Data for Create Account 
        }, 300);

        fetch('https://countriesnow.space/api/v0.1/countries/states')   //  API for State and Country for Create Account
            .then(response => response.json())
            .then(listData => {
                if (!listData.error) {
                    this.setState({ countriesAndStatesList: listData.data }, () => {
                        let countriesList: any = [];
                        countriesList = this.state.countriesAndStatesList.map((data, index) => ({
                            id: index,
                            name: data.name,
                            eventKey: "country_" + index,
                            code: data.iso3,
                        }));
                        countriesList = countriesList.filter((data, index) => data?.code === "USA" || data?.code === "CAN");
                        this.setState({ countriesList }, () => {
                            let statesList = Object.assign({}, JSON.parse(JSON.stringify(this.state.statesList)));
                            statesList = this.state.countriesAndStatesList.filter((list) => list.iso3 === "USA")[0].states;
                            statesList = statesList.map((data, index) => ({
                                id: index,
                                name: data.name,
                                eventKey: "state_" + index,
                                code: data.state_code,
                            }));
                            this.setState({ statesList });
                        });
                    })
                }
                else {
                    Utils.toastError("Something went wrong. Failed to fetch Country and State names.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "overview-3a",
                    });
                }
            })
            .catch(error => {
                Utils.toastError("Something went wrong. Failed to fetch Country and State names.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-4a",
                });
            });
    }

    getSalesEHID = (type) => {
        let request: any = {};
        request.Type = type;
        SalesService.getSalesEHID(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    if (type === "UserWise") {
                        this.setState({ salesEhidList: result.result });
                    }
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Sales EHID.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-5a",
                });
                reject();
            });
    }

    getSalesStatus = () => {
        SalesService.getSalesStatus()
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    this.setState({ statusList: result.result });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Status.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-6a",
                });
                reject();
            });
    }

    getSalesAgent = (hid) => {
        //API to get Data for Owner dropdown
        let request: any = {};
        request.HID = hid;
        SalesService.getSalesAgent(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    this.setState({ ownerList: result.result });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Agent.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-7a",
                });
                reject();
            });
    }

    getSalesSource = () => {
        SalesService.getSalesSource()
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    this.setState({ sourceList: result.result });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Source.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-8a",
                });
                reject();
            });
    }

    getSalesMarketSegment = () => {
        SalesService.getSalesMarketSegment()
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    this.setState({ margetSegmentList: result.result });
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Market Segment.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-9a",
                });
                reject();
            });
    }

    GetSalesContactById = () => {
        //debugger;
        let request: any = {};
        request.ParentID = this.state.selectedAccount.accountID;
        request.PageName = "AccountContactContainer";
        SalesService.GetSalesContactById(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    this.setState({ contactData: result.result })
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Contacts Data.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-10b",
                });
                reject();
            });
    }

    GetSalesTaskById = () => {
        // debugger;
        let request: any = {};
        request.ParentID = this.state.selectedAccount.accountID;
        request.PageName = "AccountTaskContainer";
        request.isCompleted = "No";
        SalesService.GetSalesTaskById(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result != null) {
                    //  console.log(result);                    
                    this.setState({ upcomingTasksData: result.result })
                }
                resolve();
            })
            .catch((err: any) => {
                Utils.toastError("Something went wrong. Failed to fetch Tasks Data.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-11b",
                });
                reject();
            });
    }




    toggleClass = (evt) => {
        if (evt == "details") {
            this.setState({ detailsToggle: !this.state.detailsToggle });
        }
        if (evt == "address") {
            this.setState({ addressToggle: !this.state.addressToggle });
        }
    }

    onDropdownChange = (item, type) => {
        let isDropDownChanged = false;
        let errors = Object.assign({}, JSON.parse(JSON.stringify(this.state.errors)));
        let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        let accountAddressDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));
        if (type === "ehid" && accountDetails.ehidValue !== item.id) {
            isDropDownChanged = true;
            this.getSalesAgent(item.id);
            accountDetails.lettercode = item.name;
            accountDetails.ehidValue = item.id;
            accountDetails.isEdit = "yes";
        }
        if (type === "status" && accountDetails.status !== item.id) {     
            isDropDownChanged = true;       
            accountDetails.status = item.id;
            accountDetails.statusName = item.name;
            accountDetails.isEdit = "yes";
        }
        if (type === "score" && accountDetails.accountScore !== item.id) {
            isDropDownChanged = true;
            accountDetails.accountScore = item.id;
            accountDetails.accountScoreName = item.name;
            accountDetails.isEdit = "yes";
        }
        if (type === "owner" && accountDetails.owner !== item.id) {
            isDropDownChanged = true;
            accountDetails.owner = item.id;
            accountDetails.ownerName = item.name;
            accountDetails.isEdit = "yes";
        }
        if (type === "source" && accountDetails.source !== item.id) {
            isDropDownChanged = true;
            accountDetails.source = item.id;
            accountDetails.sourceName = item.name;
            accountDetails.isEdit = "yes";
        }
        if (type === "mktsegment" && accountDetails.marketSegment !== item.id) {
            isDropDownChanged = true;
            accountDetails.marketSegment = item.id;
            accountDetails.marketSegmentName = item.name;
            accountDetails.isEdit = "yes";
        }
        if (type === "country" && accountAddressDetails.country !== item.name) {
            isDropDownChanged = true;
            let statesList = Object.assign({}, JSON.parse(JSON.stringify(this.state.statesList)));
            accountAddressDetails.country = item.name;
            accountAddressDetails.countryCode = item.code;
            accountAddressDetails.state = "";
            accountAddressDetails.stateCode = "";
            accountAddressDetails.isEdit = "yes";
            statesList = this.state.countriesAndStatesList.filter((list) => list.iso3 === item.code)[0].states;
            statesList = statesList.map((data, index) => ({
                id: index,
                name: data.name,
                eventKey: "state_" + index,
                code: data.state_code,
            }));
            /* Condition to check if all address fields are entered*/
            // if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
            //    (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
            //     errors.address = "";
            // }
            // else {
            //     errors.address = 'Please enter a valid address. A valid address contains street, city, state, zipcode and country.';      
            // }
            this.setState({ statesList });
        }
        if (type === "states" && accountAddressDetails.state !== item.name) {
            isDropDownChanged = true;
            accountAddressDetails.state = item.name;
            accountAddressDetails.stateCode = item.code;
            accountAddressDetails.isEdit = "yes";
            let isAddressMandatory = false;
            /* Condition to check if user has started typing address and so mark address fields as mandatory*/
            if (accountAddressDetails.street.length > 0 || accountAddressDetails.city.length > 0 || accountAddressDetails.state.length > 0 || accountAddressDetails.zipcode.length > 0) {
                isAddressMandatory = true;
            }
            /* Condition to check if all address fields are entered*/
            if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
                (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
                errors.address = "";
            }
            // else {
            //     errors.address = 'Please enter a valid address. A valid address contains street, city, state, zipcode and country.';      
            // }
            this.setState({ isAddressMandatory });
        }
        this.setState({ accountDetails, accountAddressDetails, errors }, () => {
            let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
            let accountAddressDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));
            if (isDropDownChanged) {
                if (type === "states" || type === "country") {
                    let formValid = this.isFormValid("address");
                    if(formValid) {
                        this.setState({ accountAddressDetailsCopy: accountAddressDetails });
                        if (type === "states") {  // update API not called when changing country as updating country will reset state and when state is updated API will be called
                            this.editAccountAddress();
                        }
                    }
                }
                else {
                    let formValid = this.isFormValid("account");
                    if(formValid) {
                        this.setState({ accountDetailsCopy: accountDetails });
                        this.editAccount(type);
                    }
                }
            }
        });
    }

    onInputFieldChange = (event: any, type: any) => {
        //debugger;
        let errors = Object.assign({}, JSON.parse(JSON.stringify(this.state.errors)));
        let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        let accountAddressDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));
        let value = event.target.value;
        if (type === "accName") {
            accountDetails.accountName = value?.toString()?.replace(/[^a-zA-Z0-9 ]+/ig, '');
            accountDetails.isEdit = "yes";
            errors.accountName = value == '' ? 'Please enter account name.' : '';
        }
        if (type === "website") {
            accountDetails.website = value;
            accountDetails.isEdit = "yes";
        }
        if (type === "taxId") {
            accountDetails.taxId = value;
            accountDetails.isEdit = "yes";
        }
        if (type === "iata") {
            accountDetails.iata = value;
            accountDetails.isEdit = "yes";
        }
        if (type === "street") {
            accountAddressDetails.street = value?.toString()?.replace(/[^a-zA-Z0-9\- ]+/ig, '');
            accountAddressDetails.isEdit = "yes";
            let isAddressMandatory = false;
            /* Condition to check if user has started typing address and so mark address fields as mandatory*/
            if (accountAddressDetails.street.length > 0 || accountAddressDetails.city.length > 0 || accountAddressDetails.state.length > 0 || accountAddressDetails.zipcode.length > 0) {
                isAddressMandatory = true;
            }
            /* Condition to reset errors state*/
            if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
                (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
                errors.address = "";
            }
            this.setState({ isAddressMandatory });
        }
        if (type === "city") {
            accountAddressDetails.city = value?.toString()?.replace(/[^a-zA-Z0-9\- ]+/ig, '');;
            accountAddressDetails.isEdit = "yes";
            let isAddressMandatory = false;
            /* Condition to check if user has started typing address and so mark address fields as mandatory*/
            if (accountAddressDetails.street.length > 0 || accountAddressDetails.city.length > 0 || accountAddressDetails.state.length > 0 || accountAddressDetails.zipcode.length > 0) {
                isAddressMandatory = true;
            }
            /* Condition to reset errors state*/
            if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
                (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
                errors.address = "";
            }
            this.setState({ isAddressMandatory });
        }
        if (type === "zip") {
            accountAddressDetails.zipcode = value?.toString()?.replace(/[^a-zA-Z0-9\- ]+/ig, '');
            accountAddressDetails.isEdit = "yes";
            let isAddressMandatory = false;
            /* Condition to check if user has started typing address and so mark address fields as mandatory*/
            if (accountAddressDetails.street.length > 0 || accountAddressDetails.city.length > 0 || accountAddressDetails.state.length > 0 || accountAddressDetails.zipcode.length > 0) {
                isAddressMandatory = true;
            }
            /* Condition to reset errors state*/
            if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
                (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
                errors.address = "";
            }
            /* Condition to reset zipcode errors state*/
            if (accountAddressDetails.zipcode?.trim().length >= 3 || accountAddressDetails.zipcode?.trim().length === 0) {
                errors.zipCode = "";
            }
            this.setState({ isAddressMandatory });
        }
        this.setState({ accountDetails, accountAddressDetails, errors });
    }

    onInputBlur = (event: any, type: any) => {
        // debugger;
        let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        let accountAddressDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));

        let isAccountChanged = JSON.stringify(accountDetails) !== JSON.stringify(this.state.accountDetailsCopy);
        let isAddressChanged = JSON.stringify(accountAddressDetails) !== JSON.stringify(this.state.accountAddressDetailsCopy);

        if(isAccountChanged || isAddressChanged) {
            if (type === "street" || type === "city" || type === "zip") {
                let formValid = this.isFormValid("address");
                if(formValid) {
                    this.setState({ accountAddressDetailsCopy: accountAddressDetails });
                    this.editAccountAddress();
                }
            }
            else {
                let formValid = this.isFormValid("account");
                if(formValid) {
                    this.setState({ accountDetailsCopy: accountDetails });
                    this.editAccount(type);
                }
            }
        }
    }

    isFormValid = (type) => {
        // debugger;
        let errors = Object.assign({}, JSON.parse(JSON.stringify(this.state.errors)));
        let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        let accountAddressDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));

        if (accountDetails.accountName === "") {
            errors.accountName = 'Account name is required.';
        } else {
            errors.accountName = "";
        }
        if (accountDetails.lettercode === "") {
            errors.lettercode = 'Ehid is required.';
        } else {
            errors.lettercode = "";
        }
        if (accountDetails.statusName === "") {
            errors.statusName = 'Status is required.';
        } else {
            errors.statusName = "";
        }
        // debugger;
        if(accountAddressDetails.isEdit !== "no") {
            if (((accountAddressDetails.street?.trim() === "" && accountAddressDetails.city?.trim() === "" && accountAddressDetails.state === "" && accountAddressDetails.zipcode?.trim() === "") ||
                (accountAddressDetails.street?.trim() !== "" && accountAddressDetails.city?.trim() !== "" && accountAddressDetails.state !== "" && accountAddressDetails.zipcode?.trim() !== ""))) {
                errors.address = "";
            }
            else {
                errors.address = 'Please enter a valid address. A valid address contains street, city, state, zipcode and country.';
            }
        }
        if(accountAddressDetails.zipcode?.trim() !== "") {
            if(accountAddressDetails.zipcode?.trim().length < 3) {
                errors.zipCode = 'Please enter a valid zip code. A valid zip code is of minimum 3 characters length.';
            }
            else {
                errors.zipCode = ""
            }
        }
        this.setState({ errors });
        // debugger;

        if (type === "account") {
            if (errors.accountName !== "") {
                Utils.toastError(errors.accountName, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-12b",
                });
                return false;
            }
            else if (errors.lettercode !== "") {
                Utils.toastError(errors.lettercode, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-13b",
                });
                return false;
            }
            else if (errors.statusName !== "") {
                Utils.toastError(errors.statusName, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-14b",
                });
                return false;
            }
            else {
                return true;
            }
        }

        if (type === "address") {
            if (errors.zipCode !== "") {
                Utils.toastError(errors.zipCode, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-15b",
                });
                return false;
            }
            else if (errors.address !== "") {
                Utils.toastError(errors.address, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "overview-16b",
                });
                return false;
            }
            else {
                return true;
            }
        }
        return false;
    }

    onTargetAccountChange = (event: any) => {
        let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        if (event.target.checked) {
            accountDetails.targetAccount = "yes";
        }
        else {
            accountDetails.targetAccount = "no";
        }
        this.setState({ accountDetails }, () => {
            let accountDetails = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
            let formValid = this.isFormValid("account");
            if(formValid) {
                this.setState({ accountDetailsCopy: accountDetails });
                this.editAccount("targetAcc");
            }
        });
    }

    renderTooltip = (value) => {
        if (value.length > 17) {
            return (
                <Tooltip id={`${value}`}>
                    {value}
                </Tooltip>
            )
        } else {
            return (
                <Tooltip style={{ opacity: 0, }} id={`${value}`}>
                    {value}
                </Tooltip>
            )
        }
    }

    handleViewAll = (activeTab) => {
        this.props.handleTabSelect(activeTab);
    }
    handleOnSelect = (row, isSelect) => {
        this.markCompleteTask(row);
        // if (isSelect) {
        //   this.setState(() => ({
        //     selected: [...this.state.selected, row.id]
        //   }));
        // } else {
        //   this.setState(() => ({
        //     selected: this.state.selected.filter(x => x !== row.id)
        //   }));
        // }
    }

    markCompleteTask = (row: any) => {
        let taskList: any = [];
        let taskItem: any = {};
        taskItem.taskID = row.taskID;
        taskList.push(taskItem);
        console.log(taskList);



        let request: any = {};
        request.taskList = taskList;
        SalesService.MarkCompleteTask(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result.saveStatus.toLowerCase() === "success") {
                    this.GetSalesTaskById();
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError("Something went wrong.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "SalesAcc1a",
                });
                reject();
            });

    }

    editAccount = (type) => {
        let request: any = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountDetails)));
        SalesService.UpdateSalesAccount(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result.saveStatus.toLowerCase() === "success") {
                    if (type === "accName" || type === "status") {
                        this.props?.updateAccNameOrStatus(this.state.accountDetails);
                    }
                    toast.success(result.message,
                        {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "SalesAcc1b",
                        });
                } else {
                    Utils.toastError(result.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "SalesAcc1c",
                    });
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError("Something went wrong.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "SalesAcc1d",
                });
                reject();
            });
    }

    editAccountAddress = () => {
        let request: any = Object.assign({}, JSON.parse(JSON.stringify(this.state.accountAddressDetails)));
        request.accountId = this.state.accountDetails.accountId;
        SalesService.UpdateSalesAccountAddress(request)
            .then(async (result: any | null) => {
                // debugger;
                if (result.saveStatus.toLowerCase() === "success") {
                    toast.success(result.message,
                        {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            containerId: "SalesAcc1e",
                        });
                } else {
                    Utils.toastError(result.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        containerId: "SalesAcc1f",
                    });
                }
                resolve();
            })
            .catch((error) => {
                Utils.toastError("Something went wrong.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    containerId: "SalesAcc1g",
                });
                reject();
            });
    }

    openModal = (type) => {
        if (type === "contact") {
            this.setState({ isCreateContact : true });
        }
    }

    closeModal = (name, type) => {
        if (name === "contact") {
            this.setState({ isCreateContact : false }, () => {
                if  (type === "refresh") {
                    this.GetSalesContactById();  // API to refresh contacts container
                }
            });
        }
    }

    contactsRowEvents = {
        onClick: (e: any, row: any, rowIndex: any) => {
            this.setState({ selectedContact: row, }, () => {
                this.setState({isShowContactSlideout: true});
            })
        }
    }

    closeSlideout = (name, type) => {
        if (name === "contactSlideout") {
            this.setState({ isShowContactSlideout: false }, () => {
                if  (type === "refresh") {
                    this.GetSalesContactById();  // API to refresh contacts container
                }
            });
        };
    }

    render() {
        const { accountDetails, errors, accountsPermissionArray } = this.state;
        let isViewOnlyAccount = this.props?.selectedAccount?.viewPermission.toLowerCase() === "view" ? true : false;  // Is this a view only account from Accounts Page
        let isCreateAccountPerm = accountsPermissionArray[0]?.createSalesAccount.toLowerCase() === "yes" ? true : false; // same perm for edit/create contact
        let isViewTaskPerm = accountsPermissionArray[0]?.viewTask.toLowerCase() === "yes" ? true : false;
        let isCreateTaskPerm = accountsPermissionArray[0]?.createTask.toLowerCase() === "yes" ? true : false;
       
       // const upcomingTasksData = [{id: 1, name: "Send Documents to Emily", due: "", type: "", assigned: "", priority: "Medium"}, {id: 2, name: "Complete new negotiated rates", due: "", type: "", assigned: "", priority: "Low"}]
        const upcomingBookingsData = [{id: 1, name: "Send Documents to Emily", type: "", startDate: "", owner: "Tina White", status: "Definite"}]
        
        const contactColumns = [
            {
                dataField: 'contactName',
                text: "Name",
            }, {
                dataField: 'title',
                text: "Title",
            }, {
                dataField: 'email',
                text: "Email",
            }, {
                dataField: 'phone',
                text: "Phone",
            }, {
                dataField: 'status',
                text: "Status",
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <>
                            {row.status != "" && (
                                <div className="status blue">
                                    {row.status}
                                </div>
                            )}
                        </>
                    );
                },
            },
        ]
        const upcomingTasksColumns = [
            {
                dataField: 'taskName',
                text: "Name",
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <EllipsisWithTooltip placement="bottom">{row.taskName}</EllipsisWithTooltip>
                    )
                }
            }, {
                dataField: 'dueDate',
                text: "Due Date",
            }, {
                dataField: 'type',
                text: "Type",
            }, {
                dataField: 'assignedUser',
                text: "Assigned",
            }, {
                dataField: 'priority',
                text: "Priority",
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <div className='d-flex'>
                            {row.priority == "High" && (
                                <div className="circle green">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <circle cx="4" cy="4" r="4" />
                                    </svg>
                                </div>
                            )}
                            {row.priority == "Medium" && (
                                <div className="circle orange">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <circle cx="4" cy="4" r="4" />
                                    </svg>
                                </div>
                            )}
                            {row.priority == "Low" && (
                                <div className="circle blue">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                        <circle cx="4" cy="4" r="4" />
                                    </svg>
                                </div>
                            )}
                            <div>{row.priority}</div>
                        </div>
                    );
                },
            },
        ]
        const upcomingBookingsColumns = [
            {
                dataField: 'name',
                text: "Name",
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <EllipsisWithTooltip placement="bottom">{row.name}</EllipsisWithTooltip>
                    )
                }
            }, {
                dataField: 'type',
                text: "Type",
                classes: 'multiple-svg',
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <div className='d-flex'>
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1648_503021)">
                                    <path d="M12.5833 15.0001C12 15.0001 11.5069 14.7987 11.1042 14.3959C10.7014 13.9931 10.5 13.5001 10.5 12.9167C10.5 12.3334 10.7014 11.8404 11.1042 11.4376C11.5069 11.0348 12 10.8334 12.5833 10.8334C13.1667 10.8334 13.6597 11.0348 14.0625 11.4376C14.4653 11.8404 14.6667 12.3334 14.6667 12.9167C14.6667 13.5001 14.4653 13.9931 14.0625 14.3959C13.6597 14.7987 13.1667 15.0001 12.5833 15.0001ZM4.66667 18.3334C4.20833 18.3334 3.81597 18.1702 3.48958 17.8438C3.16319 17.5174 3 17.1251 3 16.6667V5.00008C3 4.54175 3.16319 4.14939 3.48958 3.823C3.81597 3.49661 4.20833 3.33341 4.66667 3.33341H5.5V1.66675H7.16667V3.33341H13.8333V1.66675H15.5V3.33341H16.3333C16.7917 3.33341 17.184 3.49661 17.5104 3.823C17.8368 4.14939 18 4.54175 18 5.00008V16.6667C18 17.1251 17.8368 17.5174 17.5104 17.8438C17.184 18.1702 16.7917 18.3334 16.3333 18.3334H4.66667ZM4.66667 16.6667H16.3333V8.33341H4.66667V16.6667ZM4.66667 6.66675H16.3333V5.00008H4.66667V6.66675Z" fill="#6A6E73" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1648_503021">
                                        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>

                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1648_503022)">
                                    <g clip-path="url(#clip1_1648_503022)">
                                        <path d="M0.5 15V13.6875C0.5 13.0903 0.805556 12.6042 1.41667 12.2292C2.02778 11.8542 2.83333 11.6667 3.83333 11.6667C4.01389 11.6667 4.1875 11.6701 4.35417 11.6771C4.52083 11.684 4.68056 11.7014 4.83333 11.7292C4.63889 12.0208 4.49306 12.3264 4.39583 12.6458C4.29861 12.9653 4.25 13.2986 4.25 13.6458V15H0.5ZM5.5 15V13.6458C5.5 13.2014 5.62153 12.7951 5.86458 12.4271C6.10764 12.059 6.45139 11.7361 6.89583 11.4583C7.34028 11.1806 7.87153 10.9722 8.48958 10.8333C9.10764 10.6944 9.77778 10.625 10.5 10.625C11.2361 10.625 11.9132 10.6944 12.5312 10.8333C13.1493 10.9722 13.6806 11.1806 14.125 11.4583C14.5694 11.7361 14.9097 12.059 15.1458 12.4271C15.3819 12.7951 15.5 13.2014 15.5 13.6458V15H5.5ZM16.75 15V13.6458C16.75 13.2847 16.7049 12.9444 16.6146 12.625C16.5243 12.3056 16.3889 12.0069 16.2083 11.7292C16.3611 11.7014 16.5174 11.684 16.6771 11.6771C16.8368 11.6701 17 11.6667 17.1667 11.6667C18.1667 11.6667 18.9722 11.8507 19.5833 12.2188C20.1944 12.5868 20.5 13.0764 20.5 13.6875V15H16.75ZM7.27083 13.3333H13.75C13.6111 13.0556 13.2257 12.8125 12.5938 12.6042C11.9618 12.3958 11.2639 12.2917 10.5 12.2917C9.73611 12.2917 9.03819 12.3958 8.40625 12.6042C7.77431 12.8125 7.39583 13.0556 7.27083 13.3333ZM3.83333 10.8333C3.375 10.8333 2.98264 10.6701 2.65625 10.3438C2.32986 10.0174 2.16667 9.625 2.16667 9.16667C2.16667 8.69444 2.32986 8.29861 2.65625 7.97917C2.98264 7.65972 3.375 7.5 3.83333 7.5C4.30556 7.5 4.70139 7.65972 5.02083 7.97917C5.34028 8.29861 5.5 8.69444 5.5 9.16667C5.5 9.625 5.34028 10.0174 5.02083 10.3438C4.70139 10.6701 4.30556 10.8333 3.83333 10.8333ZM17.1667 10.8333C16.7083 10.8333 16.316 10.6701 15.9896 10.3438C15.6632 10.0174 15.5 9.625 15.5 9.16667C15.5 8.69444 15.6632 8.29861 15.9896 7.97917C16.316 7.65972 16.7083 7.5 17.1667 7.5C17.6389 7.5 18.0347 7.65972 18.3542 7.97917C18.6736 8.29861 18.8333 8.69444 18.8333 9.16667C18.8333 9.625 18.6736 10.0174 18.3542 10.3438C18.0347 10.6701 17.6389 10.8333 17.1667 10.8333ZM10.5 10C9.80556 10 9.21528 9.75694 8.72917 9.27083C8.24306 8.78472 8 8.19444 8 7.5C8 6.79167 8.24306 6.19792 8.72917 5.71875C9.21528 5.23958 9.80556 5 10.5 5C11.2083 5 11.8021 5.23958 12.2812 5.71875C12.7604 6.19792 13 6.79167 13 7.5C13 8.19444 12.7604 8.78472 12.2812 9.27083C11.8021 9.75694 11.2083 10 10.5 10ZM10.5 8.33333C10.7361 8.33333 10.934 8.25347 11.0938 8.09375C11.2535 7.93403 11.3333 7.73611 11.3333 7.5C11.3333 7.26389 11.2535 7.06597 11.0938 6.90625C10.934 6.74653 10.7361 6.66667 10.5 6.66667C10.2639 6.66667 10.066 6.74653 9.90625 6.90625C9.74653 7.06597 9.66667 7.26389 9.66667 7.5C9.66667 7.73611 9.74653 7.93403 9.90625 8.09375C10.066 8.25347 10.2639 8.33333 10.5 8.33333Z" fill="#6A6E73" />
                                    </g>
                                </g>
                                <defs>
                                    <clipPath id="clip0_1648_503022">
                                        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                    <clipPath id="clip1_1648_503022">
                                        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    )
                }
            }, {
                dataField: 'startDate',
                text: "StartDate",
            }, {
                dataField: 'owner',
                text: "Owner",
            }, {
                dataField: 'status',
                text: "Status",
                formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                        <>
                            <div className="status green">
                                {row.status}
                            </div>
                        </>
                    );
                },
            },
        ]
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: false,
            classes: 'strike-row',
            hideSelectAll: true,
            onSelect: this.handleOnSelect,
            selectionRenderer: ({ mode, ...rest }) => (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="24" height="24" rx="12" />
                    <path d="M10.711 13.294L8.412 10.999L7 12.415L10.713 16.12L17.419 9.414L16.005 8L10.711 13.294Z" />
                </svg>
            )
        };

        return (
            <div className='overview d-flex'>
                <div className='left-panel'>
                    <Accordion defaultActiveKey="0">
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle
                                    as={Button}
                                    className={this.state.detailsToggle ? "activeToggle d-flex align-items-center" : "d-flex align-items-center"}
                                    onClick={(e) => { this.toggleClass("details") }}
                                    variant="link"
                                    eventKey="0"
                                >
                                    <div>Details</div>
                                    <div className="ml-auto">
                                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 0.624902L12 6.6249L10.6 8.0249L6 3.4249L1.4 8.0249L-1.22392e-07 6.6249L6 0.624902Z" fill="#1D1E20"/>
                                        </svg>
                                    </div>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body className= {isViewOnlyAccount ? "control-readonly" : isCreateAccountPerm ? "" : "control-readonly"}>
                                    <Form.Group as={Row} className={errors.accountName.length > 0 ? "error" : ""}>
                                        <Form.Label column sm="5">Account Name</Form.Label>
                                        <Col sm="7">
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={this.renderTooltip(accountDetails.accountName)}
                                            >
                                                <Form.Control
                                                    id="acc-name"
                                                    type="text"
                                                    name="accountName"
                                                    value={accountDetails.accountName}
                                                    autoComplete="off"
                                                    onChange={(event: any) => this.onInputFieldChange(event, "accName")}
                                                    onBlur={(e) => this.onInputBlur(e, "accName")}
                                                    // placeholder="Account Name"
                                                    maxLength={100}
                                                    readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                />
                                            </OverlayTrigger>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className={errors.lettercode.length > 0 ? "error" : ""}>
                                        <Form.Label column sm="5">EHID</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.salesEhidList}
                                                onDropdownChange={this.onDropdownChange}
                                                type="ehid"
                                                selectedItem={accountDetails.lettercode}
                                                isSearchable={true}
                                                name="lettercode"
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder="Select EHID"
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className={errors.statusName.length > 0 ? "error" : ""}>
                                        <Form.Label column sm="5">Status</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.statusList}
                                                onDropdownChange={this.onDropdownChange}
                                                selectedItem={this.state.accountDetails.statusName}
                                                type="status"
                                                name="statusName"
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder="Select Status"
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Account Score</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.accountScoreList}
                                                onDropdownChange={this.onDropdownChange}
                                                selectedItem={accountDetails.accountScoreName}
                                                type="score"
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder="Select Score"
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Owner</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.ownerList}
                                                onDropdownChange={this.onDropdownChange}
                                                type="owner"
                                                selectedItem={this.state.accountDetails.ownerName}
                                                isSearchable={true}
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder={'Select Owner'}
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Source</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.sourceList}
                                                onDropdownChange={this.onDropdownChange}
                                                selectedItem={accountDetails.sourceName}
                                                type="source"
                                                isSearchable={true}
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder={'Select Source'}
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Market Segment</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.margetSegmentList}
                                                onDropdownChange={this.onDropdownChange}
                                                selectedItem={accountDetails.marketSegmentName}
                                                type="mktsegment"
                                                isSearchable={true}
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder={'Select Market Segment'}
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Website</Form.Label>
                                        <Col sm="7">
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={this.renderTooltip(this.state.accountDetails.website)}
                                            >
                                                <Form.Control
                                                    id="website"
                                                    type="text"
                                                    value={this.state.accountDetails.website}
                                                    autoComplete="off"
                                                    onChange={(event: any) => this.onInputFieldChange(event, "website")}
                                                    onBlur={(e) => this.onInputBlur(e, "website")}
                                                    // placeholder="Website"
                                                    maxLength={75}
                                                    readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                />
                                            </OverlayTrigger>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Tax ID</Form.Label>
                                        <Col sm="7">
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={this.renderTooltip(this.state.accountDetails.taxId)}
                                            >
                                                <Form.Control
                                                    id="taxid"
                                                    type="text"
                                                    // name="search"
                                                    value={this.state.accountDetails.taxId}
                                                    autoComplete="off"
                                                    onChange={(event: any) => this.onInputFieldChange(event, "taxId")}
                                                    onBlur={(e) => this.onInputBlur(e, "taxId")}
                                                    // placeholder="Tax ID"
                                                    maxLength={50}
                                                    readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                />
                                            </OverlayTrigger>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">IATA</Form.Label>
                                        <Col sm="7">
                                            <OverlayTrigger
                                                placement="bottom"
                                                overlay={this.renderTooltip(this.state.accountDetails.taxId)}
                                            >
                                                <Form.Control
                                                    id="iata"
                                                    type="text"
                                                    value={this.state.accountDetails.iata}
                                                    autoComplete="off"
                                                    onChange={(event: any) => this.onInputFieldChange(event, "iata")}
                                                    onBlur={(e) => this.onInputBlur(e, "iata")}
                                                    // placeholder="IATA"
                                                    maxLength={50}
                                                    readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                />
                                            </OverlayTrigger>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="5">Target</Form.Label>
                                        <Col sm="7">
                                            <Form.Check
                                                type="switch"
                                                id="targetAccount_1"
                                                label=""
                                                checked={this.state.accountDetails.targetAccount === "yes"}
                                                onChange={(event: any) => { this.onTargetAccountChange(event); }}
                                                disabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                    <Accordion defaultActiveKey="1">
                        <Card>
                            <Card.Header>
                                <Accordion.Toggle
                                    as={Button}
                                    className={this.state.addressToggle ? "activeToggle d-flex align-items-center" : "d-flex align-items-center"}
                                    onClick={(e) => { this.toggleClass("address") }}
                                    variant="link"
                                    eventKey="1"
                                >
                                    <div>Address</div>
                                    <div className="ml-auto">
                                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 0.624902L12 6.6249L10.6 8.0249L6 3.4249L1.4 8.0249L-1.22392e-07 6.6249L6 0.624902Z" fill="#1D1E20" />
                                        </svg>
                                    </div>
                                </Accordion.Toggle>
                            </Card.Header>
                            <Accordion.Collapse eventKey="1">
                                <Card.Body className= {isViewOnlyAccount ? "control-readonly" : isCreateAccountPerm ? "" : "control-readonly"}>
                                    <Form.Group as={Row} className={(errors.address.length > 0 && this.state.accountAddressDetails.street?.trim().length === 0) ? "error" : ""}>
                                        <Form.Label column sm="5">Street</Form.Label>
                                        <Col sm="7">
                                            <Form.Control
                                                id="street-name"
                                                type="text"
                                                // name="search"
                                                value={this.state.accountAddressDetails.street}
                                                autoComplete="off"
                                                onChange={(event: any) => this.onInputFieldChange(event, "street")}
                                                onBlur={(e) => this.onInputBlur(e, "street")}
                                                readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                // placeholder="Street"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className={(errors.address.length > 0 && this.state.accountAddressDetails.city?.trim().length === 0) ? "error" : ""}>
                                        <Form.Label column sm="5">City</Form.Label>
                                        <Col sm="7">
                                            <Form.Control
                                                id="city-name"
                                                type="text"
                                                value={this.state.accountAddressDetails.city}
                                                autoComplete="off"
                                                onChange={(event: any) => this.onInputFieldChange(event, "city")}
                                                onBlur={(e) => this.onInputBlur(e, "city")}
                                                readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                                // placeholder="City"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className={(errors.address.length > 0 && this.state.accountAddressDetails.state.length === 0) ? "error" : ""}>
                                        <Form.Label column sm="5">State</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.statesList}
                                                onDropdownChange={this.onDropdownChange}
                                                type="states"
                                                selectedItem={this.state.accountAddressDetails.state}
                                                isSearchable={true}
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder={'Select State'}
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className={(errors.address.length > 0 && this.state.accountAddressDetails.zipcode?.trim().length === 0) || errors.zipCode.length > 0  ? "error" : ""}>
                                        <Form.Label column sm="5">Zip/Postal Code</Form.Label>
                                        <Col sm="7">
                                            <Form.Control
                                                id="zip-code"
                                                type="text"
                                                value={this.state.accountAddressDetails.zipcode}
                                                autoComplete="off"
                                                onChange={(event: any) => this.onInputFieldChange(event, "zip")}
                                                onBlur={(e) => this.onInputBlur(e, "zip")}
                                                // placeholder="Zip code/Postal"
                                                maxLength={10}
                                                readOnly={isViewOnlyAccount || !isCreateAccountPerm}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} >
                                        <Form.Label column sm="5">Country</Form.Label>
                                        <Col sm="7">
                                            <DropDownSelect
                                                itemList={this.state.countriesList}
                                                onDropdownChange={this.onDropdownChange}
                                                type="country"
                                                selectedItem={this.state.accountAddressDetails.country}
                                                // isSearchable={true}
                                                isDisabled={isViewOnlyAccount || !isCreateAccountPerm}
                                            // placeholder={'Select Country'}
                                            >
                                            </DropDownSelect>
                                        </Col>
                                    </Form.Group>
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>
                </div>
                <div className='right-panel'>
                    <div className='section'>
                        <div className='header d-flex'>
                            <div className='ttl'>Contacts</div>
                            {!isViewOnlyAccount && isCreateAccountPerm &&
                                <div className='action ml-auto'>
                                    <Button variant="primary" type="button" className="btn-link" onClick={() => this.openModal("contact")}>
                                        <div className='d-flex align-items-center'>
                                            <div>Create Contact </div>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.0002 0.700195C6.54654 0.700195 6.17846 1.06828 6.17846 1.52193V6.17846H1.52193C1.06828 6.17846 0.700195 6.54654 0.700195 7.0002C0.700195 7.45385 1.06828 7.82193 1.52193 7.82193H6.17846V12.4785C6.17846 12.9321 6.54654 13.3002 7.0002 13.3002C7.45385 13.3002 7.82193 12.9321 7.82193 12.4785V7.82193H12.4785C12.9321 7.82193 13.3002 7.45385 13.3002 7.0002C13.3002 6.54654 12.9321 6.17846 12.4785 6.17846H7.82193V1.52193C7.82193 1.06828 7.45385 0.700195 7.0002 0.700195Z" />
                                            </svg>
                                        </div>
                                    </Button>
                                </div>
                            }
                        </div>
                        <div className='body'>
                            <BootstrapTable
                                keyField="id"
                                id={"contactListData"}
                                columns={contactColumns}
                                data={this.state.contactData}
                                rowEvents={this.contactsRowEvents}
                                noDataIndication={'No Contacts Yet'}
                            />
                        </div>
                        {this.state.contactData.length>0 && this.state.contactData[0].totalCount > 5 &&
                            <div className='footer'>
                                <Button variant="primary" type="button" className="btn-link" onClick={() => this.handleViewAll("contacts")}>View All</Button>
                            </div>
                        }
                    </div>
                    {!isViewOnlyAccount && isViewTaskPerm &&
                        <div className='section upcoming-task'>
                            <div className='header d-flex'>
                                <div className='ttl'>Upcoming Tasks</div>
                                {isCreateTaskPerm &&
                                    <div className='action ml-auto'>
                                        <Button variant="primary" type="button" className="btn-link">
                                            <div className='d-flex align-items-center'>
                                                <div>Create Task </div>
                                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.0002 0.700195C6.54654 0.700195 6.17846 1.06828 6.17846 1.52193V6.17846H1.52193C1.06828 6.17846 0.700195 6.54654 0.700195 7.0002C0.700195 7.45385 1.06828 7.82193 1.52193 7.82193H6.17846V12.4785C6.17846 12.9321 6.54654 13.3002 7.0002 13.3002C7.45385 13.3002 7.82193 12.9321 7.82193 12.4785V7.82193H12.4785C12.9321 7.82193 13.3002 7.45385 13.3002 7.0002C13.3002 6.54654 12.9321 6.17846 12.4785 6.17846H7.82193V1.52193C7.82193 1.06828 7.45385 0.700195 7.0002 0.700195Z" />
                                                </svg>
                                            </div>
                                        </Button>
                                    </div>
                                }
                            </div>
                            <div className='body'>
                                <BootstrapTable
                                    keyField="taskID"
                                    columns={upcomingTasksColumns}
                                    data={this.state.upcomingTasksData}
                                    selectRow={selectRow}
                                    noDataIndication={'No Tasks Yet'}
                                />
                            </div>
                            {this.state.upcomingTasksData.length > 0 && this.state.upcomingTasksData[0].totalTask > 5 &&
                                <div className='footer'>
                                    <Button variant="primary" type="button" className="btn-link" onClick={() => this.handleViewAll("tasks")}>View All</Button>
                                </div>
                            }
                        </div>
                    }
                    {!isViewOnlyAccount &&
                        <div className='section'>
                            <div className='header d-flex'>
                                <div className='ttl'>Upcoming Bookings</div>
                                <div className='action ml-auto'>
                                    <Button variant="primary" type="button" className="btn-link">
                                        <div className='d-flex align-items-center'>
                                            <div>Create Booking </div>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.0002 0.700195C6.54654 0.700195 6.17846 1.06828 6.17846 1.52193V6.17846H1.52193C1.06828 6.17846 0.700195 6.54654 0.700195 7.0002C0.700195 7.45385 1.06828 7.82193 1.52193 7.82193H6.17846V12.4785C6.17846 12.9321 6.54654 13.3002 7.0002 13.3002C7.45385 13.3002 7.82193 12.9321 7.82193 12.4785V7.82193H12.4785C12.9321 7.82193 13.3002 7.45385 13.3002 7.0002C13.3002 6.54654 12.9321 6.17846 12.4785 6.17846H7.82193V1.52193C7.82193 1.06828 7.45385 0.700195 7.0002 0.700195Z" />
                                            </svg>
                                        </div>
                                    </Button>
                                </div>
                            </div>
                            <div className='body'>
                                <BootstrapTable
                                    keyField="id"
                                    id={"contactListData"}
                                    columns={upcomingBookingsColumns}
                                    data={upcomingBookingsData}
                                    noDataIndication={'No Booking Yet'}
                                />
                            </div>
                            <div className='footer'>
                                <Button variant="primary" type="button" className="btn-link" onClick={() => this.handleViewAll("bookings")}>View All</Button>
                            </div>
                        </div>
                    }
                </div>

                {this.state.isCreateContact &&
                    <CreateContact
                        closeModal={this.closeModal}
                        accountId={this.state.selectedAccount.accountID}
                    />
                }

                {this.state.isShowContactSlideout && (
                    <ContactSlideout
                        selectedAccount={this.props.selectedAccount}
                        closeSlideout={this.closeSlideout.bind(this)}
                        selectedContactId={this.state.selectedContact?.contactID}
                    >
                    </ContactSlideout>
                )}
            </div>
        );
    }
}